









































import Vue from 'vue';
// import brand, { Brand } from '@/modules/exhibitor/brand';
// import item, { Item } from '@/modules/exhibitor/item';
import {
  brand,
  Brand,
  item,
  Item,
} from 'mostra';

import favorite from '@/modules/buyer/favorite';
// import contact from '@/modules/analysis/contact';

export type BrandInfo = {
  brand: Brand;
  checkNum: number;
};

export type ItemInfo = {
  item: Item;
  checkNum: number;
};

export type DataType = {
  brandInfo: BrandInfo | null;
  itemInfos: ItemInfo[];
};

export default Vue.extend({
  name: 'admin-analysis-favorite',
  data(): DataType {
    return {
      brandInfo: null,
      itemInfos: [],
    };
  },
  async mounted() {
    this.$loading(true);
    const id = this.$route.params.id;
    try {
      const b = await brand.load(id);
      if (!b || !b.data.owner) throw new Error('Can not get brand');
      const fs = await favorite.loadFavoritesByBrand(id);
      this.brandInfo = {
        brand: b,
        checkNum: fs.length,
      };

      const is = await item.loadsByBrandId(b.data.owner, id);

      for (const i of is) {
        if (!i || !i.id) throw new Error('Can not get item');
        const fis = await favorite.loadFavoritesByItem(i.id);
        this.itemInfos.push({
          item: i,
          checkNum: fis.length,
        });
      }
    } catch (error: any) {
      this.$error('ブランドの取得に失敗しました。', error);
    } finally {
      this.$loading(false);
    }
  },
});
